import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Typography,
} from "@suraasa/placebo-ui"
import { useEffect, useState } from "react"

import { UploadedTeacherData } from "./constants"
import ReviewState from "./review-state"
import UploadState from "./upload-state"

const AddMultipleTeacherDialog = ({
  open,
  onClose,
  // alreadyAddedTeachers,
  onSubmit,
}: {
  open: boolean
  onClose: () => void
  // alreadyAddedTeachers?: OrganizationUserType[]
  onSubmit: () => void
}) => {
  const [files, _setFiles] = useState<FileList | null | string>(null)

  const [step, setStep] = useState<
    "upload" | "no-seat-left" | "view-data" | null
  >("upload")
  const [sheetData, setSheetData] = useState<UploadedTeacherData[]>([])

  const setFiles = (f: FileList | null | string) => {
    _setFiles(f)
  }
  // useEffect(() => {
  //   if (noOfSearAvailable === 0) {
  //     setStep("no-seat-left")
  //   } else {
  //     setStep("upload")
  //   }
  // }, [noOfSearAvailable])

  const reset = () => {
    setSheetData([])
    setStep("upload")
    setFiles(null)
  }

  useEffect(() => {
    if (!open) {
      reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-xl">
        <DialogHeader className="!border-0 p-2.5 pb-1.25">
          <DialogTitle>
            <Typography variant="title3">Add Teachers from CSV</Typography>
          </DialogTitle>
        </DialogHeader>
        {/* {!step && (
          <>
            <DialogBody></DialogBody>
            <DialogFooter></DialogFooter>
          </>
        )} */}
        {step === "upload" && (
          <UploadState
            sheetData={sheetData}
            onClickContinue={() => {
              setStep("view-data")
            }}
            onUpdateSheetData={(data) => {
              setSheetData(data)
            }}
            files={files}
            setFiles={setFiles}
          />
        )}
        {step === "view-data" && (
          <ReviewState
            onUploadAgain={() => {
              setStep("upload")
              setFiles(null)
            }}
            sheetData={sheetData}
            onSubmit={() => {
              onSubmit()
              onClose()
            }}
            files={files}
            setFiles={setFiles}
            // alreadyAddedTeachers={alreadyAddedTeachers}
          />
        )}
        {/* {step === "no-seat-left" && <SeatLimitError />} */}
      </DialogContent>
    </Dialog>
  )
}

export default AddMultipleTeacherDialog
